import { useState, useEffect } from "react";

import Button from "@mui/material/Button";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import AppointmentDefaultView from "./component/AppointmentDefaultView";
import AppointmentCalendarView from "./component/AppointmentCalendarView";
import BookAppointmentsModal from "./modals/BookAppointmentsModal.js";

import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import isUserLoggedIn from "./helpers/redirect";
import { useNavigate, useLocation } from "react-router-dom";

const ExpertAppointmentDB = () => {
  const [defaultView, setDefaultView] = useState(true);
  const [sortCriteria, setSortCriteria] = useState("date");
  const [selectedTab, setSelectedTab] = useState("Upcoming");
  const [loading, setLoading] = useState(true);
  const [isBookModalOpen, setIsBookModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  // Check if user is logged in
  // useEffect(() => {
  //   const isLoggedIn = isUserLoggedIn();

  //   if (!isLoggedIn) {
  //     // Redirect to "/login"
  //     //navigate('/login');
  //     window.location.href = `https://www${process.env.REACT_APP_CLIENT_DOMAIN}/`;
  //   }
  // }, [location, navigate]);

  const handleTabChange = (e) => {
    setSelectedTab(e.target.innerText);
    setLoading(true);
  };
  const handleChange = (event) => {
    setSortCriteria(event.target.value);
  };

  const handleView = () => {
    setDefaultView(!defaultView);
  };

  const handleOpenBookModal = () => {
    setIsBookModalOpen(true);
  };

  const handleCloseBookModal = () => {
    setIsBookModalOpen(false);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleSearch = () => {
    // Trigger search by updating loading state to refetch data
    setLoading(true);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <div className="my-3 ExpertAppointmentDashboard">
      <div className="ExpertAppointmentDashboard--Header d-flex">
        <div className="d-flex Header--Left">
          <h2>Appointments{!defaultView && " > Calendar"}</h2>
          <div className="d-flex gap-2 align-items-center">
            <TextField
              placeholder="Search appointments..."
              value={searchQuery}
              onChange={handleSearchChange}
              onKeyPress={handleKeyPress}
              size="small"
              sx={{
                minWidth: 250,
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                  backgroundColor: "#fff",
                  border: "2px solid #e0e0e0",
                  height: "50px",
                  "&.Mui-focused": {
                    borderColor: "#1976d2",
                  },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end" sx={{ margin: 0 }}>
                    <Button
                      onClick={handleSearch}
                      variant="contained"
                      disableElevation
                      size="small"
                      className="PrimaryCTAExp"
                      sx={{
                        minWidth: "auto",
                        px: 1,
                        py: 0.5,
                        fontSize: "0.75rem",
                        height: "32px",
                        margin: 0,
                      }}
                    >
                      Search
                    </Button>
                  </InputAdornment>
                ),
              }}
            />

            <Button
              onClick={handleView}
              variant="contained"
              disableElevation
              className=" PrimaryCTAExp"
            >
              <CalendarMonthOutlinedIcon />
              View {defaultView ? "Calendar" : "Appointments"}
            </Button>

            <Button
              onClick={handleOpenBookModal}
              variant="contained"
              disableElevation
              className=" PrimaryCTAExp"
            >
              <AddIcon />
              Book Appointment
            </Button>
          </div>
        </div>

        <div className="d-flex Header--Right">
          {defaultView && (
            <div
              style={{ background: "#f0f0f0" }}
              className="d-flex rounded-pill p-1 gap-2  Options"
            >
              <div
                className={`Option--Item rounded-pill  py-2 px-3 ${
                  selectedTab == "Upcoming" ? "SelectedItem" : ""
                }`}
                onClick={(e) => handleTabChange(e)}
              >
                Upcoming
              </div>
              <div
                className={`Option--Item rounded-pill  py-2 px-3 ${
                  selectedTab == "Past" ? "SelectedItem" : ""
                }`}
                onClick={(e) => handleTabChange(e)}
              >
                Past
              </div>
            </div>
          )}

          {defaultView && (
            <div className="Selectors d-flex gap-2 d-none">
              <p>Sort by</p>

              <FormControl fullWidth>
                <Select
                  labelId="simple-select-label"
                  id="simple-select"
                  value={sortCriteria}
                  displayEmpty
                  onChange={handleChange}
                >
                  <MenuItem value={"date"}>Date</MenuItem>
                  <MenuItem value={"time"}>Time</MenuItem>
                  <MenuItem value={"name"}>Name</MenuItem>
                  <MenuItem value={"duration"}>Duration</MenuItem>
                </Select>
              </FormControl>
            </div>
          )}
        </div>
      </div>

      <div>
        {defaultView ? (
          <AppointmentDefaultView
            selectedTab={selectedTab}
            loading={loading}
            setLoading={setLoading}
            searchQuery={searchQuery}
          />
        ) : (
          <AppointmentCalendarView />
        )}
      </div>

      <BookAppointmentsModal
        open={isBookModalOpen}
        onClose={handleCloseBookModal}
      />
    </div>
  );
};

export default ExpertAppointmentDB;
